export function removeItem(item, list) {
  let index = list.indexOf(item);
    if (index > -1) {
      list.splice(index, 1);
    }
}

export function clearAllSelectedItems(supportObj) {
  let { testNodeList, 
    bundleList, 
    seasonalPromotionList, 
    selectedTestIdList,
    selectedDiscountPanelIdList,
    selectedXChooseYPanelIdList,
    selectedCustomPanelIdList,
    selectedSeasonalPromoList,
    selectedShortcutIdList
  } = supportObj;
  let testList = testNodeList.map(node => node.value);
  testList.concat(bundleList).concat(seasonalPromotionList).forEach(item => item.isSelect = false);
  emptyArray(selectedTestIdList);
  emptyArray(selectedDiscountPanelIdList);
  emptyArray(selectedXChooseYPanelIdList);
  emptyArray(selectedCustomPanelIdList);
  emptyArray(selectedSeasonalPromoList);
  emptyArray(selectedShortcutIdList);
}

function emptyArray(array) {
  array.splice(0, array.length);
}